<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="">
        <!-- <hamburger
          id="hamburger-container"
          :is-active="sidebar.opened"
          class="hamburger-container"
          @toggleClick="toggleSideBar"
        /> -->
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="">
        <!-- <hamburger
          id="hamburger-container"
          :is-active="sidebar.opened"
          class="hamburger-container"
          @toggleClick="toggleSideBar"
        /> -->
        <img
          :src="consoleLogo ? consoleLogo : require('../../../assets/images/logo.png')"
          class="logo"
          width="180px"
          height="36px"
          v-if="!hasNeuTralConfig || (hasNeuTralConfig && consoleLogo)"
        />
      </router-link>
    </transition>
  </div>
</template>

<script>
import variables from '@/assets/scss/style.scss'
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import Hamburger from '@/components/Hamburger'
export default {
  name: 'SidebarLogo',
  components: {
    Hamburger
  },
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(['sidebar']),
    ...mapState({
      hasNeuTralConfig: (state) => state.nutral.hasNeuTralConfig,
      consoleLogo: (state) => state.nutral.consoleLogo
    }),
    variables() {
      return variables
    },
    sideTheme() {
      return this.$store.state.settings.sideTheme
    }
  },
  data() {
    return {}
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #00bfbf;
  text-align: center;
  overflow: hidden;
  border-right: 1px solid #11d3d3;
  // display: none;
  .hamburger-container {
    padding: 0px 0px 0px 20px !important;
    line-height: 60px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    .logo {
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
